export const fieldsTranslations = {
  email: "correo electrónico",
  password: "contraseña",
  non_field_errors: "campo indefinido"
}